// extracted by mini-css-extract-plugin
export default {"child-option-quantity-editor":"configurator-web-child-option-quantity-editor"};